import { useCallback, useMemo, useState } from 'react';

const US_TIMEZONES = new Set([
  'America/New_York', 'America/Detroit', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello',
  'America/Indiana/Indianapolis', 'America/Indiana/Vincennes', 'America/Indiana/Winamac',
  'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Vevay',
  'America/Indiana/Tell_City', 'America/Indiana/Knox', 'America/Chicago', 'America/Menominee',
  'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/North_Dakota/Beulah',
  'America/Denver', 'America/Boise', 'America/Phoenix', 'America/Los_Angeles', 'America/Anchorage',
  'America/Juneau', 'America/Sitka', 'America/Metlakatla', 'America/Yakutat', 'America/Nome',
  'America/Adak', 'Pacific/Honolulu', 'US/Eastern', 'US/Central', 'US/Mountain', 'US/Pacific',
  'US/Alaska', 'US/Hawaii', 'US/Arizona',
]);

export const detectUSVisitor = () => {
  if (typeof window === 'undefined') return false;
  const region = new URLSearchParams(window.location.search).get('region');
  if (region) return region.toLowerCase() === 'us';
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
  if (langs.some((l) => /-US$/i.test(l || ''))) return true;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return US_TIMEZONES.has(tz);
};

export const useIsUSVisitor = () => useMemo(detectUSVisitor, []);

const DISMISS_KEY = 'mgp_us_tariff_notice_dismissed';

export const useUSTariffNotice = () => {
  const isUS = useIsUSVisitor();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });
  const dismiss = useCallback(() => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch {}
    setDismissed(true);
  }, []);
  return { show: isUS && !dismissed, dismiss };
};

export default useIsUSVisitor;
